import { ReactUtils } from '@festina-life/core'
import cx from 'classnames'
import type { ComponentProps } from 'react'

import { ButtonLoadingContent } from '../../actions/button/ButtonLoadingContent'
import { typographyStyles } from '../../structure/typography/styles'
import { severityColorStyles } from '../alert/severityColorStyles'
import type { Severity } from '../alert/types'
import { Tooltip } from '../tooltip/Tooltip'

type Props = {
  color?: Severity | 'primary'
  label: string
  className?: string
  isLoading?: boolean
  tip?: ComponentProps<typeof Tooltip>['tip']
}

export const Badge = ({
  label,
  color = 'primary',
  className,
  isLoading = false,
  tip,
}: Props) => (
  <ReactUtils.ConditionalWrap
    condition={!!tip}
    wrap={(children) => <Tooltip tip={tip}>{children}</Tooltip>}
  >
    <span
      className={cx(
        'items-center justify-center rounded-3xl px-2 py-1 relative',
        typographyStyles({
          size: 'sm',
          weight: 'semibold',
        }),
        isLoading && 'min-w-6 h-6', // to ensure loading spinner has space
        'whitespace-nowrap', // since badges are used for short texts, we can use nowrap to prevent wrapping
        'inline-flex', // ensures padding is applied correctly regards of parent container display styles
        color === 'primary'
          ? 'bg-primary-400 dark:bg-primary-600 text-primary-950 dark:text-primary-50'
          : severityColorStyles(color),
        className,
      )}
    >
      <ButtonLoadingContent isLoading={isLoading}>{label}</ButtonLoadingContent>
    </span>
  </ReactUtils.ConditionalWrap>
)
